import { render, staticRenderFns } from "./SearchCustomerSelection.vue?vue&type=template&id=2510608d&scoped=true&"
import script from "./SearchCustomerSelection.vue?vue&type=script&lang=js&"
export * from "./SearchCustomerSelection.vue?vue&type=script&lang=js&"
import style0 from "./SearchCustomerSelection.vue?vue&type=style&index=0&id=2510608d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2510608d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
